/* Seed insights / blog posts — replace with CMS content later. */

export const POSTS = [
    {
        slug: "freight-cost-leakage-australia-2026",
        title: "Where freight cost leaks hide in Australian invoices",
        category: "Cost Control",
        date: "December 2025",
        readMinutes: 6,
        excerpt:
            "An analysis of the five most common surcharge categories driving avoidable spend on AU-bound containers — and how to spot them before approving the invoice.",
        cover:
            "https://images.pexels.com/photos/16229885/pexels-photo-16229885.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        body: [
            "Most freight invoices contain three to seven line items beyond the headline ocean rate. By the time the AP team receives them, the original quote has long been archived — and discrepancies quietly become normal.",
            "We see five recurring leakage categories on AU-bound containers in 2025: origin local charges drift, ISPS surprises, AMS/ENS surcharges, detention day creep, and rounding on chargeable weight conversions. None are dramatic on their own. Together they routinely add 4–11% to landed cost.",
            "The fix isn't more spreadsheets. It's tying every charge back to the original quote at the shipment level and making variances visible before payment, not three months later in a quarterly review.",
        ],
    },
    {
        slug: "apac-freight-update-december-2025",
        title: "APAC freight market update — December 2025",
        category: "Market Update",
        date: "December 2025",
        readMinutes: 4,
        excerpt:
            "Rates from North Asia to East-coast Australia softened slightly week-on-week, while CMA CGM and ONE announced new GRI attempts for early Q1. Here's what AU importers should plan for.",
        cover:
            "https://static.prod-images.emergentagent.com/jobs/2da4906e-da56-4c5d-bd4c-278bf8ff8295/images/4d95bd61613c5bce5a7030d0b90d4a5e7c8f919410f6aad6631cc3171909274f.png",
        body: [
            "Spot rates on Shanghai → Sydney softened by ~3% week-on-week as post-peak season demand normalised. East-coast vessel utilisation remains in the mid-80s.",
            "Two carriers have announced GRI attempts for mid-January — historically these stick at 40–60% of the published amount on AU trades. We recommend pre-booking critical cargo for the first half of January.",
            "Origin local charges in South China continue to climb. We're seeing a 6% lift in THC + documentation fees vs. October. Push for fixed-charge schedules in tender responses, not floating rates.",
        ],
    },
    {
        slug: "incoterms-2025-cheat-sheet-aus",
        title: "Incoterms 2025 — what AU importers and exporters actually need",
        category: "Trade Guide",
        date: "November 2025",
        readMinutes: 8,
        excerpt:
            "A pragmatic walk-through of the four Incoterms that cover 90% of AU import/export contracts, and the costly mistakes we see businesses make on FOB vs. FCA.",
        cover:
            "https://images.unsplash.com/photo-1494412574643-ff11b0a5c1c3?auto=format&fit=crop&w=1200&q=70",
        body: [
            "Incoterms exist to allocate cost and risk. Most AU SMEs use four: FOB, FCA, CIF, and DAP. The other seven exist but rarely apply in day-to-day trade.",
            "The single biggest mistake we see is buying FOB on a containerised shipment. FCA is almost always the correct term — FOB was designed for bulk and break-bulk where cargo crosses the ship's rail. With containers, your risk should transfer at the terminal gate, not at the rail.",
            "DAP feels convenient but transfers full inbound visibility to the supplier's nominated forwarder. If you're paying for it anyway, you're better off with CIF + your own forwarder on the AU leg.",
        ],
    },
];

export const findPost = (slug) => POSTS.find((p) => p.slug === slug);
